import React, { Component } from "react";
import "./GridCars.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CarModel from "../CarModel/CarModel";
import { isMobile } from "react-device-detect";
import { fetchAutos } from "../../actions/cars";
import store from "../../store";

class gridCars extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: "1",
      models: []
    };
  }

  componentDidMount = () => {
    store.dispatch(fetchAutos()).then(() => this.fillAutos());
  };

  fillAutos = () => {
    console.log("FILL AUTOS" + store.getState().carsReducer.autos);

    this.setState({ models: store.getState().carsReducer.autos });
  };

  handleChange = event => {
    console.log(event.target.id);
    this.setState({ selected: event.target.id });
  };

  render() {
    return (
      <Grid container className={isMobile ? "GridCarMobile" : "GridCarWeb"}>
        <Grid item xs={11} sm={11}>
          <div className={isMobile ? "TitleMobile" : "Title"}>
            Elegí tu próximo modelo, ¡0KM, cero vueltas!
          </div>
          <div className="Title-middle">
            Todos los modelos están disponibles, listos para ser patentados.
            ¡Reservá el tuyo ahora!
          </div>
        </Grid>

        {isMobile ? (
          <Grid item xs={12} className="ModelButtons">
            <div
              id="1"
              onClick={this.handleChange}
              className={
                this.state.selected === "1"
                  ? "ModelButtonSelected"
                  : "ModelButton"
              }
            >
              COROLLA
            </div>
            <div
              id="2"
              onClick={this.handleChange}
              className={
                this.state.selected === "2"
                  ? "ModelButtonSelected"
                  : "ModelButton"
              }
            >
              ETIOS
            </div>
            <div
              id="3"
              onClick={this.handleChange}
              className={
                this.state.selected === "3"
                  ? "ModelButtonSelected"
                  : "ModelButton"
              }
            >
              YARIS
            </div>
            <div
              id="4"
              onClick={this.handleChange}
              className={
                this.state.selected === "4"
                  ? "ModelButtonSelected"
                  : "ModelButton"
              }
            >
              HILUX
            </div>
            <div
              id="5"
              onClick={this.handleChange}
              className={
                this.state.selected === "5"
                  ? "ModelButtonSelected"
                  : "ModelButton"
              }
            >
              SW4
            </div>
            <div
              id="6"
              onClick={this.handleChange}
              className={
                this.state.selected === "6"
                  ? "ModelButtonSelected"
                  : "ModelButton"
              }
            >
              RAV4
            </div>
          </Grid>
        ) : null}
        <Grid item xs={12}>
          {this.state.models.map(model => (
            <CarModel name={model.modelo} />
          ))}
        </Grid>
        <Grid item xs={12}>
          <div className="CarModelDesc">
            Precios válidos únicamente para realizar una reserva online y de
            contado. Exenta está la posibilidad de financiación y/o permuta.{" "}
            <br />
            Para más información XXXX-XXXX o consultas@prana.com.ar
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default gridCars;
